<!-- close button -->
<button class="pos-absolute top-6 right-6 top-1-s right-1-s p-a-5 cursor-pointer button-icon"
        type="button"
        (click)="close()"
        aria-label="Close modal window">
    <i class="fs-4 icon-close"
       aria-hidden="true"></i>
</button>

<!-- modal contents -->
<div class="bg-col-w p-a-6 p-t-8 modal-body">
    <ng-content></ng-content>
</div>